<template>
  <div>
    <!-- search input -->
    <section id="knowledge-base-search">
      <b-card
        no-body
        class="knowledge-base-bg text-center"
        :style="{backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`}"
      >
        <b-card-body class="card-body">
          <h2 class="text-primary">
            {{ $t('sms.sms_templates') }}
          </h2>
          <b-row>
            <b-col
              md="6"
              offset="3"
            >
              <b-form-group>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="filter_form_query.search"
                    :placeholder="$t('generals.search')"
                    type="text"
                    class=""
                    @input="searchTemplates"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="3"
              class="justify-content-between"
            >
              <b-button
                v-b-modal.modal-sms-template
                variant="primary"
                class="mx-auto"
                @click="openTemplateModal"
              >
                <feather-icon
                  icon="PlusIcon"
                />
                {{ $t('sms.new_sms_template') }}
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </section>
    <section id="knowledge-base-content">
      <!-- content -->
      <b-row>
        <b-col
          v-for="(temp, index) in GET_MAIL_TEMPLATES"
          :key="index"
          md="4"
          sm="6"
        >
          <b-card
            class="text-center cursor-pointer"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-button
                v-b-modal.modal-sms-template
                size="sm"
                variant="warning"
                @click="editButtonClicked(temp)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                size="sm"
                variant="danger"
                class="ml-1"
                @click="deleteClick(temp.id)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>

            <h4>{{ temp.title }}</h4>
            <b-tabs
              content-class="pt-1"
              fill
            >
              <b-tab
                title="Uz"
              >
                <pre class="mt-1 w-100 sms-body">
                  {{ temp.body.uz }}
                </pre>
              </b-tab>
              <b-tab
                title="Ru"
              >
                <pre class="mt-1 w-100 sms-body">
                  {{ temp.body.ru }}
                </pre>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <!-- <b-modal
      id="modal-new-sms-template"
      ref="add-template"
      title="Новый шаблон SMS"
      centered
    >
      <b-card-text>
        <b-form-group
          label="Название шаблона"
        >
          <b-form-input v-model="smsTemplate.title" />
        </b-form-group>
        <b-form-group
          label="Содержимое SMS"
          description="% - лицевой счёт, @ - Ф.И.О. заёмщика, $ - Сумма, & - дни просрочки"
        >
          <b-form-textarea
            v-model="smsTemplate.description"
            label="Text input with lazy formatter (on blur)"
            rows="3"
          />
        </b-form-group>
      </b-card-text>

      <template #modal-footer="{ }">
        <b-button
          size="sm"
          variant="danger"
          @click="cancelAddingTemplate()"
        >
          Отменить
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="addNewTemplate()"
        >
          Сохранить
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-edit-sms-template"
      title="Редактирование шаблона SMS"
      centered
    >
      <b-card-text>
        <b-form-group
          label="Название шаблона"
        >
          <b-form-input v-model="smsTemplate.title" />
        </b-form-group>
        <b-form-group
          label="Содержимое SMS"
          description="% - лицевой счёт, @ - Ф.И.О. заёмщика, $ - Сумма, & - дни просрочки"
        >
          <b-form-textarea
            v-model="smsTemplate.description"
            label="Text input with lazy formatter (on blur)"
            rows="3"
          />
        </b-form-group>
      </b-card-text>

      <template #modal-footer="{ }">
        <b-button
          size="sm"
          variant="danger"
        >
          Отменить
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="editTemplate()"
        >
          Сохранить
        </b-button>
      </template>
    </b-modal> -->
    <template-modal
      :is-edit="is_editing"
      :sms-template="sms_template"
      @saveSuccess="FETCH_MAIL_TEMPLATES"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BFormInput, BFormGroup, BButton, VBModal, BInputGroup, BInputGroupPrepend, BTabs, BTab,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import TemplateModal from './components/templateModal.vue'

export default {
  components: {
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BFormInput,
    FeatherIcon,
    BInputGroup,
    BInputGroupPrepend,
    TemplateModal,
    BTabs,
    BTab,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      knowledgeBaseSearchQuery: '',
      templates: [
        { title: this.$t('sms.sms_template'), description: '#13' },
      ],
      smsTemplate: {
        title: '',
        description: '',
      },
      filter_form_query: {
        search: '',
      },
      sms_template: {
        body: {},
      },
      is_editing: false,
      delay: 500,
    }
  },
  computed: {
    ...mapGetters('sms', ['GET_MAIL_TEMPLATES']),
  },
  mounted() {
    this.FETCH_MAIL_TEMPLATES()
  },
  methods: {
    ...mapActions('sms', ['FETCH_MAIL_TEMPLATES', 'DELETE_SMS_TEMPLATE']),
    searchTemplates() {
      clearTimeout(this.delay)
      this.delay = setTimeout(() => {
        this.FETCH_MAIL_TEMPLATES({ search: this.filter_form_query.search })
      }, 500)
    },
    openTemplateModal() {
      this.is_editing = false
      this.sms_template = {
        body: {},
      }
    },
    editButtonClicked(data) {
      console.log(data)
      this.sms_template = data
      this.is_editing = true
    },
    deleteClick(id) {
      this.$_showAreYouSureModal().then(val => {
        if (val) {
          this.DELETE_SMS_TEMPLATE(id).then(() => {
            this.$_successToast(this.$t('generals.deleted'))
            this.FETCH_MAIL_TEMPLATES()
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-knowledge-base.scss';
  .sms-body {
    overflow-x: auto;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
    text-align: left;
    background: none !important;
    background-color: none;
  }
</style>
